import {observable, computed} from "mobx";
import TimesheetService from "../../../services/TimesheetService";
import _ from "lodash";

//RHFPP-1447-automatizacao-timesheets
export default class TimesheetsNaoGeradosStore {

    @observable timesheets;
    @observable loading;
    @observable importModal;
    @observable files;
    @observable rejectedfiles;
    @observable invalidFilesMsgs;
    @observable errorMensage;
    @observable isLoading;
    @observable sucessoImportacao;
    @observable errorsImportacao;
    @observable observacoes;

    constructor() {
        this.isLoading = false;
        this.importModal = false;
        this.files = [];
        this.rejectedfiles = [];
        this.errorMensage = "";
        this.timesheets = [];
        this.sucessoImportacao = [];
        this.errorsImportacao = [];
        this.timesheetService = new TimesheetService();
        this.observacoes = "";
    }

    toogleImportModal() {
        this.files = [];
        this.rejectedfiles = [];
        this.sucessoImportacao = [];
        this.errorsImportacao = [];
        this.isLoading = false;
        this.importModal = !this.importModal;

        // Limpar backdrop quando modal fecha (importModal passa de true para false)
        if (!this.importModal) {
            this.limparBackdropDoBody();
        }
    }

    // Remove classes de backdrop do body e elementos residuais do DOM
    // Chamado quando modal fecha para evitar overlay stacking
    limparBackdropDoBody() {
        // Usar setTimeout pequeno para garantir que React finalizou a atualização
        setTimeout(() => {
            const possuiModalAberta = document.querySelector('.modal.in, .modal.show');
            if (possuiModalAberta) {
                return;
            }

            const body = document.querySelector('body');
            if (body) {
                // Remove ambas as classes de modal
                body.classList.remove('ReactModal__Body--open');
                body.classList.remove('modal-open');
                // Restaura padding-right removido pelo Modal
                body.style.paddingRight = '';
                if (!body.style.cssText.trim()) {
                    body.removeAttribute('style');
                }
            }
            
            // Neutraliza backdrops residuais sem removê-los do DOM, evitando conflito com o React.
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.classList.remove('show');
                backdrop.classList.remove('in');
                backdrop.style.display = 'none';
                backdrop.style.opacity = '0';
                backdrop.style.pointerEvents = 'none';
                backdrop.setAttribute('aria-hidden', 'true');
            });
            
            // Oculta overlays do ReactModal residuais
            const overlays = document.querySelectorAll('.ReactModal__Overlay');
            overlays.forEach(overlay => {
                overlay.style.display = 'none';
                overlay.style.pointerEvents = 'none';
            });
        }, 0);
    }

    @computed
    get acoesMultiplas() {
        return [];
        //return (_.find(this.timesheets, {status: "ERR"}))
        //? ["aprovarTimesheet"]
        //: _.find(this.timesheets, {status: "PFL"}) ? ["enviarTimesheet"] : [];
    }

    carregarLista() {
        this.loading = true;
        const loadingPromises = Promise.all([
            this.timesheetService.listarTimesheetsNaoGerados().then(response => {
                this.timesheets = response.data;
            }).catch(error => {
                console.log(error);
            })
            
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    setLista(value) {
        this.timesheets = value;
    }

}